import TreeNodeSet from "./TreeNodeSet";

// TODO: This class shall not do any scrolling
// TODO: Table shall subscribe to expand / collapse events and update UI itself
export default class ExpandController {
    constructor(tree, collapsedNodeIds) {
        this.tree = tree;
        this.nodeSet = new TreeNodeSet();
        if (collapsedNodeIds) {
            const rootNode = this.tree.getRootNode();
            for (let i = 0; i < collapsedNodeIds.length; i++) {
                const treeNode = rootNode.getNodeById(collapsedNodeIds[i]);
                if (treeNode)
                    this.nodeSet.add(treeNode);
            }
        }
    }

    expand(treeNode) {
        this.nodeSet.remove(treeNode);
        this.tree.updateUIForSingleTreeNode(treeNode);
    }

    getElementHeight(elm) {
        const elmHeight = elm.offsetHeight;
        let elmMargin;
        if (document.all) {  // IE
            const marginTop = parseInt(elm.currentStyle.marginTop, 10);
            const marginBottom = parseInt(elm.currentStyle.marginBottom, 10);
            elmMargin = ( isNaN(marginTop) ? 0 : marginTop ) + ( isNaN(marginBottom) ? 0 : marginBottom );
        } else {  // Mozilla
            elmMargin = parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-top')) + parseInt(document.defaultView.getComputedStyle(elm, '').getPropertyValue('margin-bottom'));
        }
        return elmHeight + elmMargin;
    }

    expandAndScrollIfNeeded(treeNode) {
        this.expand(treeNode);
        this.scrollToIfNeeded(treeNode);
    }

    scrollToIfNeeded(treeNode) {
        const nodeEl = this.tree.getUIObjectForNode(treeNode).nodeEl;
        const treePanel = this.tree.treeContainer.parentNode;

        const nodeElHeight = this.getElementHeight(nodeEl) + 2;

        const customScroll = this.tree.customScroll;
        if (customScroll) {
            // if there is custom scroll - use scroll own functions
            const expandedNodeBottomPosition = nodeEl.offsetTop + nodeElHeight - treePanel.offsetHeight;
            if (Math.min(nodeEl.offsetTop, expandedNodeBottomPosition) > Math.abs(customScroll.y)) // scroll only if top of nodEl will be in visible area
            {
                customScroll.scrollToElement(nodeEl, 200, null, -(customScroll.wrapperHeight - nodeElHeight));
            }
        }
        else {
            const to = Math.min(nodeEl.offsetTop, nodeEl.offsetTop + nodeElHeight - treePanel.offsetHeight);

            if (to > treePanel.scrollTop) {
                const scrollerCtor = function(panel, to) {
                    this.panel = panel;
                    this.to = to;
                    this.scroll = function() {
                        if (this.panel.scrollTop < this.to) {
                            const lastScrollTop = this.panel.scrollTop;
                            this.panel.scrollTop += ((this.to - this.panel.scrollTop) / 10) + 1;
                            if (this.panel.scrollTop <= lastScrollTop) // prevent indefinite updates
                                return;
                            const me = this;
                            setTimeout(function() { me.scroll() }, 7);
                        }
                        else {
                            this.panel.scrollTop = this.to;
                        }
                    }
                };

                new scrollerCtor(treePanel, to).scroll();
            }
        }
    }

    collapse(treeNode) {
        if (!treeNode.isCollapsible())
            return;
        this.nodeSet.add(treeNode);
        this.tree.updateUIForSingleTreeNode(treeNode)
    }

    toggle(treeNode) {
        if (this.isCollapsed(treeNode))
            this.expand(treeNode);
        else
            this.collapse(treeNode);
    }

    isExpanded(treeNode) {
        return !this.isCollapsed(treeNode);
    }

    isCollapsed(treeNode) {
        return treeNode.isCollapsible() ? this.nodeSet.contains(treeNode) : false;
    }

    getCollapsedNodeSet() {
        return this.nodeSet;
    }

    expandSubtree(treeNode) {
        if (!treeNode.hasChildren())
            return;
        this.expandChildren(treeNode);
        this.expand(treeNode);
    }

    expandChildren(treeNode) {
        const children = treeNode.getChildren();
        for (let i = 0; i < children.length; i++)
            this.expandSubtree(children[i]);
    }

    collapseSubtree(treeNode) {
        if (!treeNode.hasChildren())
            return;
        this.collapseChildren(treeNode);
        this.collapse(treeNode);
    }

    collapseChildren(treeNode) {
        const children = treeNode.getChildren();
        for (let i = 0; i < children.length; i++)
            this.collapseSubtree(children[i]);
    }
}



// WEBPACK FOOTER //
// ./web/js/hierarchySelector/tree/ExpandController.js